import { ElementComponents } from '@/components/sections/builder/builder-element';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { ElementType, ThemeType } from '@/stores/builder';

export default function HeaderElement({
  elements,
  theme,
}: {
  elements: ElementType[];
  theme?: ThemeType;
}) {
  const headerElements = elements?.filter((element) => element.group === 'header');
  const headerElement = headerElements?.find((e) => e.type === 'header');
  const headerData = headerElement?.data as HeaderElementDataType;

  return (
    <>
      <link rel='icon' href={headerData?.faviconUrl} type='image/x-icon' />
      <div id='wrapper-header'>
        {headerElements.map((element) => {
          const Element = ElementComponents[element.type].Element;
          if (Element) return <Element element={element} key={element.id} theme={theme} />;
        })}
      </div>
    </>
  );
}
